import React from 'react'
import { Row } from 'react-bootstrap'

import FlujoFondosList from './FlujoFondosList'
import { useColocacionEditContext } from 'features/Colocacion/ColocacionViewContext'
import { ColocacionSectionCard } from '../../ColocacionSectionCard'
import { AddIcon } from 'components/BymaIcons'

import { ColocacionSummary } from 'features/Colocacion/ColocacionSummary'
import { Loading } from 'components'
import { LocalErrorProvider } from 'core'

const FlujoFondosSection = () => {
  const props = useColocacionEditContext()

  return (
    <ColocacionSectionCard title='Agregar Flujo de Fondos' icon={AddIcon}>
      <Row className='mb-3'>
        <ColocacionSummary {...props} showTitulo={true} />
      </Row>
      <Row className='p-0'>
        <Loading>
          <LocalErrorProvider>
            <FlujoFondosList {...props} />
          </LocalErrorProvider>
        </Loading>
      </Row>
    </ColocacionSectionCard>
  )
}

export default FlujoFondosSection
